import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteICTData } from '../../../../../store/uiSlice';

const DeleteICTData = ({ record, onClose }) => {
    const dispatch = useDispatch();

    const handleDelete = () => {
        dispatch(deleteICTData(record.id));
        onClose();
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h3>Confirm Delete</h3>
                <p>Are you sure you want to delete this record?</p>
                <button onClick={handleDelete} className='fa fa-trash delete'></button>
                <button onClick={onClose} className='fa fa-x'></button>
            </div>
        </div>
    );
};

export default DeleteICTData;
